import 'jquery-ui/ui/widgets/datepicker'

export default {
  init: function () {

      $(".datepicker").datepicker({
        dateFormat: 'mm-dd-yy',
      });

      $(".staff-checkbox").change(function() {

        let checked = 0;

        if($(this).is(':checked')) {

          checked = 1;

        } else {

          checked = 0;

        }

        var delivery_id = $(this).attr('data-delivery-id');

        // eslint-disable-next-line no-undef
        jQuery.post(ajax_vars.ajax_url, {action: "staff_checked_delivery", delivery_id: delivery_id, checked: checked, security: ajax_vars.ajax_nonce}, function (response, status, jqXHR) {

          if (jqXHR.status != 200 || response == 'false')
            return;

        }, 'JSON');


      });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/deliverymanifest.js